import { createSlice } from "@reduxjs/toolkit";
import { getUpdateDishesStatusAPI } from "../../api/dishes";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
}; 

const getUpdateDishesStatusSlice = createSlice({
  name: "getUpdateDishesStatus",
  initialState: data,
  reducers: {
   getUpdateDishesStatusSlice(state) {
      state.isLoading = true;
    },
   getUpdateDishesStatusSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    getUpdateDishesStatusSliceFailure(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
   getUpdateDishesStatusSliceReset(state) {
      state.isLoading = false;
      state.data = null;
    },
  },
});
export const getUpdateDishesStatusHandler = (id:any,data:any) => async (dispatch: any) => {
  try {
    dispatch(getUpdateDishesStatusAction.getUpdateDishesStatusSlice());
    const response: any = await getUpdateDishesStatusAPI(id,data);
    
    dispatch(getUpdateDishesStatusAction.getUpdateDishesStatusSliceSuccess(response));
  } catch (e: any) {
    dispatch(getUpdateDishesStatusAction.getUpdateDishesStatusSliceFailure(e?.response?.data));
  }
};
export default getUpdateDishesStatusSlice.reducer;
export const getUpdateDishesStatusAction = getUpdateDishesStatusSlice.actions;
